'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var classnames = require('classnames');
var React = require('react');
var reactVirtuoso = require('react-virtuoso');
var styled = require('styled-components');
require('../../../../enums/accordion.js');
require('../../../../enums/alert.js');
require('../../../../enums/avatar.js');
require('../../../../enums/breakpoints.js');
require('../../../../enums/button.js');
require('../../../../enums/code-editor.js');
require('../../../../enums/colors.js');
require('../../../../enums/combobox.js');
require('../../../../enums/date.js');
require('../../../../enums/drag-and-drop.js');
require('../../../../enums/dialog.js');
require('../../../../enums/divider.js');
require('../../../../enums/dropdown.js');
require('../../../../enums/fieldset.js');
require('../../../../enums/font-icon.js');
require('../../../../enums/fonts.js');
require('../../../../enums/headings.js');
require('../../../../enums/input.js');
require('../../../../enums/keys.js');
var list$1 = require('../../../../enums/list.js');
require('../../../../enums/listbox.js');
require('../../../../enums/loader.js');
require('../../../../enums/margin.js');
require('../../../../enums/option.js');
require('../../../../enums/pill.js');
require('../../../../enums/placements.js');
require('../../../../enums/popout.js');
require('../../../../enums/privacy.js');
require('../../../../enums/radio-group.js');
require('../../../../enums/status.js');
require('../../../../enums/switch.js');
require('../../../../enums/table.js');
require('../../../../enums/tooltip.js');
require('../../../../enums/transitions.js');
require('../../../../enums/widths.js');
require('../../../../styles/styled-components/alert.js');
require('../../../../styles/styled-components/animations.js');
var boxShadow = require('../../../../styles/styled-components/box-shadow.js');
require('../../../../styles/styled-components/button.js');
require('../../../../themes/alert.js');
require('../../../../themes/button.js');
require('../../../../themes/checkbox.js');
require('../../../../themes/divider.js');
require('../../../../themes/dropdown.js');
require('../../../../themes/fieldset.js');
require('../../../../themes/input.js');
require('../../../../themes/list.js');
require('../../../../themes/listbox.js');
require('../../../../themes/loader.js');
require('../../../../themes/option.js');
require('../../../../themes/popout.js');
require('../../../../themes/switch.js');
var themes = require('../../../../themes/themes.js');
require('../../../../themes/tooltip.js');
require('../../../../styles/styled-components/font-face.js');
require('../../../../styles/styled-components/global.js');
require('../../../../styles/styled-components/input.js');
var list = require('../../../../styles/styled-components/list.js');
require('../../../../styles/styled-components/listitem.js');
require('../../../../styles/styled-components/media-queries.js');
require('../../../../styles/styled-components/reset.js');
require('../../../../styles/styled-components/outline.js');
require('../../../../styles/styled-components/popout.js');
require('../../../../styles/styled-components/screen-reader.js');
require('../../../../styles/styled-components/switch.js');
require('../../../../styles/styled-components/tooltip.js');
require('../../../atoms/icon/font-icon/font-icon.js');
require('react-transition-group');
require('../../../atoms/alert/inline-alert/inline-alert.js');
require('../../../atoms/alert/standard-alert/standard-alert.js');
require('boring-avatars');
require('../../../atoms/tooltip/hover-tooltip/hover-tooltip.js');
require('react-laag');
require('../../../../utilities/color.js');
require('date-fns');
require('../../../../utilities/locale.js');
require('@brandfolder/utilities');
require('../../../atoms/button/close-button/close-button.js');
require('../../../atoms/button/color-button/color-button.js');
require('../../../../hooks/use-prevent-keyboard-scrolling.js');
require('../../../atoms/button/icon-button/icon-button.js');
require('../../../atoms/button/standard-button/standard-button.js');
var circleLoader = require('../../../atoms/loader/circle-loader/circle-loader.js');
require('../../../atoms/loader/shimmer-loader/shimmer-loader.js');
require('../../../atoms/divider/standard-divider/standard-divider.js');
require('../../../atoms/fieldset/standard-fieldset/standard-fieldset.js');
require('../../../atoms/heading/standard-heading/standard-heading.js');
require('../../../atoms/label/standard-label/standard-label.js');
require('../../../atoms/link/button-link/button-link.js');
require('../../../atoms/link/standard-link/standard-link.js');
require('../../../atoms/popout/standard-popout/standard-popout.js');
require('../../../atoms/screen-reader/only-for-screen-reader/only-for-screen-reader.js');
require('../../../atoms/table/standard-table/caption.js');
require('../../../atoms/table/standard-table/tbody.js');
require('../../../atoms/table/standard-table/tr-empty.js');
require('../../../atoms/table/standard-table/td.js');
require('../../../atoms/table/standard-table/tr.js');
require('../../../atoms/table/standard-table/table.js');
require('../../../atoms/table/standard-table/tfoot.js');
require('../../../atoms/table/standard-table/th.js');
require('../../../atoms/table/standard-table/thead.js');
require('../../../atoms/table/dnd-table/dnd-handle-td.js');
require('../../../atoms/table/dnd-table/dnd-table-drag-context.js');
require('../../../atoms/text/help-text/help-text.js');
require('../../../atoms/text/standard-text/standard-text.js');
var standardListitem = require('../../listitem/standard-listitem/standard-listitem.js');
var baseList = require('../base-list/base-list.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var classnames__default = /*#__PURE__*/_interopDefaultCompat(classnames);
var React__default = /*#__PURE__*/_interopDefaultCompat(React);
var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const borderWidth = 1;
const height = 250;
const padding = 10;
const UnstyledList = /*#__PURE__*/ React.forwardRef((props, ref)=>{
    const { className , labels ={} , listItemProps , listItems , loading , virtualized , virtualizedProps , ...otherProps } = props;
    const { loaderLabel  } = labels;
    const isVirtualized = virtualized && listItems.length > 10;
    return /*#__PURE__*/ React__default.default.createElement(baseList.BaseList, _extends({}, otherProps, {
        className: classnames__default.default({
            'bf-list__standard': true,
            'bf-list__standard--virtualized': isVirtualized,
            [`${className}`]: !!className
        }),
        ref: ref
    }), loading && loaderLabel && /*#__PURE__*/ React__default.default.createElement(standardListitem.StandardListItem, _extends({}, listItemProps), /*#__PURE__*/ React__default.default.createElement(circleLoader.CircleLoader, {
        label: loaderLabel
    })), !loading && isVirtualized && /*#__PURE__*/ React__default.default.createElement(reactVirtuoso.Virtuoso, _extends({}, virtualizedProps, {
        className: classnames__default.default({
            'bf-list__virtualized': true,
            [`${virtualizedProps?.className}`]: !!virtualizedProps?.className
        }),
        itemContent: (index)=>{
            return /*#__PURE__*/ React__default.default.createElement(standardListitem.StandardListItem, _extends({}, listItemProps, {
                key: listItems[index].key
            }), listItems[index].children);
        },
        style: {
            height: height - borderWidth * 2
        },
        totalCount: listItems.length
    })), !loading && !isVirtualized && listItems.map((listItem)=>{
        return /*#__PURE__*/ React__default.default.createElement(standardListitem.StandardListItem, _extends({}, listItemProps, {
            key: listItem.key
        }), listItem.children);
    }));
});
const StyledList = styled__default.default(UnstyledList)`
  ${list.baseListStyle}
  ${boxShadow.boxShadowLists}
  ${list.getListVirtualizedCss({
    borderWidth,
    height,
    padding
})}
  ${({ look  })=>list.getListTheme({
        look
    })}
  min-width: 100px;

  &.bf-list__standard--virtualized {
    overflow: unset;
    padding: 0;
  }

  .bf-list__virtualized {
    > div {
      padding: ${padding}px ${padding}px 0;

      > div > div {
        &:last-child {
          padding-bottom: ${padding}px;
        }
      }
    }
  }
`;
/**
 * https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Roles/list_role
 *
 * @param props StandardListProps
 * @returns FunctionComponent<StandardListProps>
 */ const StandardList = /*#__PURE__*/ React.forwardRef((props, ref)=>{
    const { look =list$1.ListLooks.Default , ...otherProps } = props;
    const themeContext = React.useContext(styled.ThemeContext);
    return /*#__PURE__*/ React__default.default.createElement(styled.ThemeProvider, {
        theme: themeContext || themes.lightTheme
    }, /*#__PURE__*/ React__default.default.createElement(StyledList, _extends({}, otherProps, {
        look: look,
        ref: ref
    })));
});

exports.StandardList = StandardList;
//# sourceMappingURL=standard-list.js.map
